module.exports = __webpack_public_path__ + "img/mjollnir_arc.001.bb787b30.png";